import { useContext } from 'react'
import {
  AnalysisProgressContext,
  AnalysisProgressContextValue,
} from '@/contexts/analysis-progress-context'

// Custom Hook
export function useAnalysisProgress(): AnalysisProgressContextValue {
  const context = useContext(AnalysisProgressContext)
  if (!context) {
    throw new Error('useAnalysisProgress must be used within AnalysisProgressProvider')
  }
  return context
}

// Safe version that returns null if provider is not available
export function useAnalysisProgressSafe(): AnalysisProgressContextValue | null {
  const context = useContext(AnalysisProgressContext)
  return context || null
}
